import echarts from 'echarts'

const mixinCreateEchart = {
  data () {
    return {
      isFirstCreate: false
    }
  },
  watch: {
    'value': {
      handler () {
        if (!this.isFirstCreate) {
          this.isFirstCreate = true
        }
        if (this.echart) {
          this.echart.hideLoading()
          this.changeEchart()
        } else {
          this.$nextTick(() => {
            this.createEchart()
            window.addEventListener('resize', () => {
              this.echart.resize()
            })
            this.changeEchart()
          })
        }
      },
      deep: true
    }
  },
  mounted () {
    this.loadingSetting()
    // this.$nextTick(() => {
    // })
  },
  methods: {
    createEchart () {
      this.echart = echarts.init(this.$refs['echart'])
      this.echart.setOption(
        this.option
      )
      window.addEventListener('resize', () => {
        this.echart.resize()
      })
    },
    loadingSetting () {
      var loadingNodata = function (api, opts) {
        opts = {
          text: 'no data',
          color: '#c23531',
          textSize: 14,
          textColor: 'rgb(153, 153, 153)',
          maskColor: 'rgba(255, 255, 255, 0.8)',
          zlevel: 0
        }
        var mask = new echarts.graphic.Rect({
          style: {
            fill: opts.maskColor
          },
          zlevel: opts.zlevel,
          z: 10
        })
        var labelRect = new echarts.graphic.Rect({
          style: {
            fill: 'none',
            text: opts.text,
            // textPosition: 'right',
            textDistance: 10,
            fontSize: 14,
            textFill: opts.textColor
          },
          zlevel: opts.zlevel,
          z: 11
        })
        var group = new echarts.graphic.Group()
        group.add(labelRect)
        group.add(mask) // Inject resize

        group.resize = function () {
          var cx = api.getWidth() / 2
          var cy = api.getHeight() / 2
          labelRect.setShape({
            x: cx - 10,
            y: cy - 10,
            width: 10 * 2,
            height: 10 * 2
          })
          mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
          })
        }
        group.resize()
        return group
      }
      echarts.registerLoading('nodatas', loadingNodata)
    }
  }
}

export {mixinCreateEchart}
